import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { Field, FieldLabel } from 'designSystem/components/Field'
import { ItemGroup } from 'designSystem/components/Item'
import { BugReportAgentModeOption } from 'features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeOption'
import {
  type BugReportAgentMode,
  bugReportAgentModeSchema,
} from 'features/knowledgeDocumentViewer/utils/viewerBugReport'

const AGENT_MODE_LABELS: Record<BugReportAgentMode, MessageDescriptor> = {
  ticket_only: msg`Ticket only`,
  review: msg`Review and propose`,
  resolve: msg`Fully resolve`,
}

const AGENT_MODE_DESCRIPTIONS: Record<BugReportAgentMode, MessageDescriptor> = {
  ticket_only: msg`Create a Linear ticket.`,
  review: msg`Explain the problem and propose options.`,
  resolve: msg`Implement a fix and open a PR.`,
}

type BugReportAgentModeFieldProps = {
  value: BugReportAgentMode
  disabled?: boolean
  onChange: (mode: BugReportAgentMode) => void
}

export function BugReportAgentModeField({
  value,
  disabled = false,
  onChange,
}: BugReportAgentModeFieldProps) {
  const { t, i18n } = useLingui()
  return (
    <Field>
      <FieldLabel>{t`Agent automation`}</FieldLabel>
      <ItemGroup>
        {bugReportAgentModeSchema.options.map((option) => (
          <BugReportAgentModeOption
            key={option}
            value={option}
            label={i18n._(AGENT_MODE_LABELS[option])}
            description={i18n._(AGENT_MODE_DESCRIPTIONS[option])}
            selected={option === value}
            disabled={disabled}
            onSelect={onChange}
          />
        ))}
      </ItemGroup>
    </Field>
  )
}
